import type { CaptureOptions, CaptureResult, Properties } from 'posthog-js';
import posthog from 'posthog-js';

/**
 * Track an event in PostHog
 * @param eventName The name of the event to track
 * @param installationId The installation ID to group the event by
 * @param eventProperties Optional properties to attach to the event
 */
export const trackClientEvent = (
  eventName: string,
  installationId: string | null | undefined,
  eventProperties?: Properties | null,
  options?: CaptureOptions,
): CaptureResult | undefined => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    return posthog.capture(
      eventName,
      {
        ...eventProperties,
        ...(installationId && {
          $groups: { installation: installationId },
        }),
      },
      options,
    );
  } catch (error) {
    console.error('Failed to track event:', error);
    return undefined;
  }
};
